import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalService } from '../global.service';
import { LoginUser } from '../../models/authorization/login-user.model';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class AuthHttpService {
    // private get headers() {
    //     const accessToken: string = `Bearer ${localStorage.getItem('__bt')}`;
    //     const headers: HttpHeaders = new HttpHeaders({
    //         'Content-Type': 'application/json',
    //         Authorization: accessToken,
    //     });
    //     return headers;
    // }

    constructor(
        private httpClient: HttpClient,
        private globalService: GlobalService,
    ) {}

    registerUser(model: any) {
        return this.httpClient.post(
            `${this.globalService.mainHost}/account/register`,
            model,
        );
    }

    registerMobileUser(model: any) {
        return this.httpClient.post(
            `${this.globalService.mainHost}/account/registerMobileUser`,
            model,
        );
    }

    loginUser(data) {
        const outData = {
            ...data,
            Password: btoa(data.UserName.toString() + data.Password.toString()),
        };
        return this.httpClient.post(
            `${this.globalService.mainHost}/account/login`,
            outData,
        );
    }

    logoutUser() {
        return this.httpClient
            .get(`${this.globalService.mainHost}/account/logout`)
            .pipe(map(data => data['Data']));
    }

    resetPassword(email) {
        const params = new HttpParams().set('emailId', email);
        return this.httpClient.get(
            `${this.globalService.mainHost}/account/resetPassword`,
            { params },
        );
    }

    changePassword(changeData: any) {
        //console.log(changeData);

        const httpHeaders = new HttpHeaders({
            Token: changeData.Token,
            username: changeData.UserName,
        });
        const passCode = btoa(changeData.UserName + changeData.Pass);
        return this.httpClient.post(
            `${this.globalService.mainHost}/account/changePasswordWOL`,
            { PassCode: passCode,"UserName":changeData.UserName,"Token":changeData.Token }
        );
    }

    updateUSer(userData) {
        return this.httpClient.post(
            `${this.globalService.mainHost}/account/editProfile`,
            userData,
           
        );
    }

    getUserDetails(): Observable<{ Data: LoginUser }> {
        const accessToken: string = `Bearer ${localStorage.getItem('__bt')}`;
        
         let header = new HttpHeaders({ "Authorization": accessToken});

         const requestOptions = {  headers: header}; 
        return this.httpClient.get<{ Data: LoginUser }>(
            `${this.globalService.mainHost}/account/loginUser`,requestOptions
            
        );
    }
    
    visitorActivity() {
        return this.httpClient.get(
            `${this.globalService.mainHost}/account/visitorActivity`,
           
        );
    }

    

}
